export const METER_ID_PREFIX = "meter-";

export function getMeterIdFromSelectedId(selectedId?: string) {
  return selectedId?.startsWith(METER_ID_PREFIX)
    ? Number(selectedId?.replace(METER_ID_PREFIX, ""))
    : undefined;
}
